import React, { useContext } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";

import CloseIcon from "@mui/icons-material/Close";

import Alias from "../User/Alias";
import AnalyserContext from "./analyserContext";
import useClasses from "../useClasses";

const styles = (theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(2, 1, 0, 2),
  },
  iconButton: {
    padding: theme.spacing(1),
  },
});

function Title() {
  const classes = useClasses(styles);
  const { analyserDispatch } = useContext(AnalyserContext);
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Alias size="small" />
      <Tooltip title={t("common.actions.close")}>
        <IconButton
          size="small"
          onClick={() => analyserDispatch({ type: "TOGGLE_SURVEYS" })}
          className={classes.iconButton}
        >
          <CloseIcon fontSize="small"></CloseIcon>
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default Title;
